import { IRatingCount, IReviewSource } from '@common-types';
import { Rate } from 'antd';

interface RatingSummaryProps {
    averageRating: number;
    totalReviews: number;
    ratingCounts: IRatingCount[];
    sources?: IReviewSource[];
}

export const RatingSummary: React.FC<RatingSummaryProps> = ({ averageRating, totalReviews, ratingCounts, sources }) => {
    // Ensure we have all ratings from 1 to 5
    const fullCounts = [5, 4, 3, 2, 1].map(r => {
        const found = ratingCounts.find(item => item.rating === r);
        return { rating: r, count: found ? found.count : 0 };
    });

    const maxCount = Math.max(...fullCounts.map(c => c.count));

    const providerText = sources && sources.length > 0
        ? sources.map(s => {
            const name = s.provider.toLowerCase();
            return name.charAt(0).toUpperCase() + name.slice(1);
        }).join(' & ')
        : '';

    return (
        <div className="rating-summary">
            <div className="average-rating-box">
                <div className="rating-number">{averageRating}</div>
                <div className="stars-container">
                    <Rate disabled defaultValue={averageRating} allowHalf />
                </div>
                <div className="review-count">based on {totalReviews} reviews</div>
            </div>

            <div className="rating-bars-container">
                {providerText && (
                    <div className="sources-text">
                        Total reviews and rating from {providerText}
                    </div>
                )}
                <div className="rating-bars">
                    {fullCounts.map(({ rating, count }) => (
                        <div key={rating} className="rating-bar-item">
                            <div className="label">{rating} stars</div>
                            <div className="bar-container">
                                <div
                                    className="bar-fill"
                                    style={{ width: `${(count / maxCount) * 100}%` }}
                                ></div>
                            </div>
                            <div className="count">{count}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
